import { fetchWithToken } from "../../../api/apiutils";

export const postLotAnalysis = async (id) => {
  const res = await fetchWithToken(`/api/lots/${id}/analysis?newVersion=true`, {
    method: "POST",
  });

  let json = null;
  try {
    json = await res.json();
  } catch {
    json = null;
  }

  if (!res.ok) {
    const error = new Error(json?.Message || "POST analysis error");
    error.code = json?.Code || null;
    error.details = json;
    throw error;
  }

  return json;
};

export const getLotFilesData = async (lotId) => {
  const res = await fetchWithToken(`/api/lots/${lotId}/files/data?type=TechnicalSpecification`);
  if (!res.ok) {
    const json = await res.json().catch(() => null);
    const error = new Error(json?.Message || "GET files error");
    error.code = json?.Code || null;
    error.details = json;
    throw error;
  }
  return res.json();
};

export const getLotAnalysisSummary = async (id) => {
  const res = await fetchWithToken(`/api/lots/${id}/analysis/summary`);

  let json = null;
  try { json = await res.json(); } catch {}

  if (!res.ok) {
    const error = new Error(json?.Message || "Ошибка получения анализа");
    error.code = json?.Code || null;
    error.details = json;
    throw error;
  }

  return json;
};

